import React from 'react';
import { Helmet } from 'react-helmet-async';

const BookingSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Complete Your Booking | Airport Parking Deals",
    "description": "Complete your airport parking booking with Airport Parking Deals. Secure payment, instant confirmation, and best price guarantee.",
    "url": "https://airportparkingdeals.co.uk/booking",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://airportparkingdeals.co.uk"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Search",
          "item": "https://airportparkingdeals.co.uk/search"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Booking",
          "item": "https://airportparkingdeals.co.uk/booking"
        }
      ]
    },
    "potentialAction": {
      "@type": "ReserveAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://airportparkingdeals.co.uk/booking"
      },
      "result": {
        "@type": "Reservation",
        "name": "Airport Parking Reservation"
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default BookingSchema;

